import { SemanticICONS } from 'semantic-ui-react';
export const API_URL: string = process.env.NODE_ENV === "development"
  ? "http://localhost:5006"
  : "https://myapi.cdp.dental";

export const mycdp_uri = 'https://my.cdp.dental';

export interface SubMenu {
  pageId?: number;
  name: string;
  icon: SemanticICONS;
  redirectUrl?: string,
  title: string;
  role: string[];
  hide?: boolean;
  customIcon?: string;
}

export interface MainMenu {
  class: string;
  customIcon?: string;
  icon: SemanticICONS;
  name: string;
  pageId?: number;
  partner: string;
  subMenus?: SubMenu[];
  title: string;
  role: any;
  hide?: boolean;
  parentLink?: string;
}

export const brands = [
  {text: 'All', value: 'All', key: 'All'},
  {text: 'SMD', value: 'SMD', key: 'SMD'},
  {text: 'FSD', value: 'FSD', key: 'FSD'},
  {text:'OTD',value:'OTD',key:'OTD'},
  {text:'SDD',value:'SDD',key:'SDD'},
  {text:'3CD',value:'3CD',key:'3CD'},
  {text:'SYN',value:'SYN',key:'SYN'}
];


export const doctorPracticeTypes: { [key: string]: string } = {'1': '1 Dr', '2': '2 Dr', '3': 'Denovo'};


export const HelpPages: any = {
  1: { name: "UDR - SCHEDULE" },
  2: { name: "UDR - CARE" },
  3: { name: "UDR - Care Delta" },
  4: { name: "UDR - Future Care Review" },
  6: { name: "UDR - USAGE" },
  7: { name: "UDR - EXTERNALSITES" },
  9: { name: "UDR - DOCS", totalChild: 3 },
  10: { name: "UDR - Dentists View", parent: 9 },
  11: { name: "UDR - Admin List View", parent: 9 },
  12: { name: "UDR - Document List View", parent: 9 },
  13: { name: "UDR - REPORTS", totalChild: 4 },
  14: { name: "UDR - Care", parent: 13 },
  15: { name: "UDR - Adjustments", parent: 13 },
  16: { name: "UDR - Writeoffs", parent: 13 },
  17: { name: "UDR - Standard of Care", parent: 13 },
  18: { name: "UDR - PRACTICES" },
  19: { name: "UDR - OVERVIEW" },
  20: { name: "UDR - MOBILE" },
  21: { name: "UDR - TimeOff Requests" },
  22: { name: "UDR - Doc View By Dentist" },
  23: { name: "UDR - Manage My Profile" },
  24: { name: "UDR - bGOAL < = > bCARE" },
  25: { name: "UDR - bGOAL < = > bCARE REPORT" },
  26: { name: "UDR - BUDGET BGOAL" },
  27: { name: "UDR - CARE DELTA REPORT" },
  28: { name: "UDR - TIME OFF REQUEST SUMMARY" },
  29: { name: "UDR - OFFERED WORK DAYS" },
  30: { name: "UDR - BITEWING REPORT NOTES" },
  31: { name: "UDR - CLINICAL CONSTITUTION"},
  32: { name: "UDR - powerBI"},
  33: { name: "UDR - Cdp", totalChild: 2},
  34: { name: "UDR - Ortho", totalChild: 2},
  301: { name: "UDR - CLINICAL CONSTITUTION DASHBOARD"},
  302: { name: "UDR - CLINICAL - Clinical Excellence", totalChild: 1},
  303: { name: "UDR - CLINICAL - Clinical Excellence - Todo Reviews", parent: 302},
  35: { name: "CDP Pay", parent: 33},
  36: { name: "CDP Reports", parent: 33},
  37: { name: "Ortho Pay", parent: 34},
  38: { name: "Ortho Reports", parent: 34},
  39: { name: "MY.CDP - Patient Validation"},
  40: { name: "MY.CDP - Adjustment", totalChild: 2},
  41: { name: "MY.CDP - Adjustment - Setup", parent: 40},
  42: { name: "MY.CDP - Adjustment Acknowledgement", parent: 40},
  43: { name: "MY.CDP - Five9 List"},
  44: { name: "MY.CDP - OS PCR"},
  45: { name: "MY.CDP - MDHM"},
  46: { name: "MY.CDP - CSR"},
  47: { name: "MY.CDP - Patient Care Report"},
  48: { name: "MY.CDP - Practice Manager Dashboard"},
  49: { name: "MY.CDP - SPORE"},
  50: { name: "MY.CDP - SPORE Notifications"},
  60: { name: "Credentialing - List Of Providers" },
  61: { name: "Credentialing - Provider Application" },
  62: { name: "Credentialing - Provider Documents" },
  63: { name: "Credentialing - My Files > Provider View" },
  64: { name: "Credentialing - My Files > Admin List View" },
  65: { name: "Credentialing - My Files > Document List View" },
  66: { name: "Credentialing - My Files > Doc View By Dentist" },
  67: { name: "Credentialing - My Files > Wall Documents" },
  68: { name: "Credentialing - My Files > Wall Documents ALT" },
  69: { name: "Credentialing - Provider Roster" },
  70: { name: "Credentialing - Practice Information" },
  71: { name: "Credentialing - Textract" },
  72: { name: "Credentialing - Practice View" },
  80: { name: "Recruitment - Recruiting" },
  81: { name: "Recruitment - Tasks" },
  82: { name: "Recruitment - Setup > Lead Status" },
  83: { name: "Recruitment - Setup > School" },
  84: { name: "Recruitment - Setup > Leads Interest" },
  85: { name: "Recruitment - Setup > Tasks" },
  86: { name: "Recruitment - Setup > Funnel Status" },
  87: { name: "Recruitment - Setup > Process Status" },
  88: { name: "Recruitment - Setup > Current Dentist" },
  89: { name: "Recruitment - Setup > Potential Dentist" },
  90: { name: "Recruitment - Setup > How you heard" },
  91: { name: "Recruitment - Setup > Email" },
  92: { name: "Recruitment - Setup > Tags" },
  93: { name: "Recruitment - Events" },
  94: { name: "Recruitment - Calendar" },
  95: { name: "Recruitment - Activity Feed" },
  96: { name: "Recruitment - Dr Movement" },
  // 97: { name: "Recruitment - Quicksights" },
  98: { name: "Recruitment - Usage" },
  100: { name: "CDP Alerts - Alerts" },
  101: { name: "CDP Alerts - Setup" },
  102: { name: "CDP Alerts - Usage" },
  110: { name: "Referrals - All Referrals" },
  111: { name: "Referrals - Setup > Ortho > Procedure Codes" },
  112: { name: "Referrals - Setup > Ortho > Status Setup" },
  113: { name: "Referrals - Setup > Ortho > Notification" },
  114: { name: "Referrals - Setup > Oral Surgery > Procedure Codes" },
  115: { name: "Referrals - Setup > Oral Surgery > Status Setup" },
  116: { name: "Referrals - Setup > Oral Surgery > Notification" },
  117: { name: "Referrals - Reports" },
  118: { name: "Referrals - Usage" },
  121: { name: "CDP LEADS - new Leads" },
  122: { name: "CDP LEADS - Recare Patients" },
  140: { name: "CDP SCHEDULE - Reports > OPEN CLOSED MISMATCH REPORT" },
  141: { name: "CDP SCHEDULE - Reports > TS/TE MISMATCH REPORT" },
  142: { name: "CDP SCHEDULE - Reports > DOCTOR WORK HISTORY REPORT" },
  143: { name: "CDP SCHEDULE - Dentists Substitute Costs" },
  144: { name: "CDP SCHEDULE - Usage" },
  150: { name: "BILLING - PatientFinance > Credit Cards to Run" },
  151: { name: "BILLING - PatientFinance> Setup > Setup Actions" },
  152: { name: "BILLING - PatientFinance> Setup > Setup Status" },
  153: { name: "BILLING - PatientFinance> Setup > Setup Assignments" },
  154: { name: "BILLING - PatientFinance> Setup > Setup QA Status" },
  155: { name: "BILLING - PatientFinance> Setup > Setup Xcharge" },
  156: { name: "BILLING - PatientFinance> Reports > Daily Payments Report"},
  157: { name: "BILLING - PatientFinance > Collection Reports" },
  158: { name: "BILLING - PatientFinance> PayPlan QA Issues" },
  159: { name: "BILLING - Usage Report" },
  160: { name: "BILLING - Claims" },
  161: { name: "BILLING - Production v Collection" },
  162: { name: "SITES - Practices " },
  163: { name: "SITES - Admin" },
  164: { name: "SITES - Responsibility Matrix" },
  165: { name: "SITES - Usage" },
  166: { name: "SITES - Practice Table" },
  167: { name: "SITES - Practice Holidays" },
    168: { name: "ADMIN - Users" },
    169: { name: "ADMIN - Provider Profile" },
    170: { name: "ADMIN - Xray Service Dashboard" },
    171: { name: "ADMIN - User Matrix" },
    172: { name: "ADMIN - Manual Uploads > Patient Count And Care" },
    173: { name: "ADMIN - Goal > PCR Goal" },
    174: { name: "ADMIN - Goal > Oral Surgery Goal" },
    175: { name: "ADMIN - SOFD > Re Run PCR" },
    176: { name: "ADMIN - SOFD > MCO Login Report" },
    177: { name: "ADMIN - SOFD > Available Api List" },
    178: { name: "ADMIN - SOFD > Crons" },
    179: { name: "ADMIN - SOFD > Lambdas" },
    180: { name: "ADMIN - SOFD > DCRM Automation Status" },
    181: { name: "ADMIN - SOFD > MCO Scrapper" },
    182: { name: "ADMIN - SOFD > Adjustment List" },
    183: { name: "ADMIN - SOFD > Write Off List" },
    184: { name: "ADMIN - SOFD > Email Configurations" },
    185: { name: "ADMIN - SETUP > Practice" },
    186: { name: "ADMIN - SETUP > MCO" },
    187: { name: "ADMIN - SETUP > Regions" },
    188: { name: "ADMIN - SETUP > Carrier Identity" },
    189: { name: "ADMIN - SETUP > Procedure Code Change" },
    190: { name: "ADMIN - SETUP > GOX Precedure Code" },
    191: { name: "ADMIN - SETUP > GOZ Precedure Code" },
    192: { name: "ADMIN - SETUP > Manager Help" },
    193: { name: "ADMIN - SETUP > Leap Edit" },
    194: { name: "ADMIN - SETUP > Spot Commlog Search" },
    195: { name: "ADMIN - SETUP > Notification Emails" },
    196: { name: "ADMIN - SETUP > Brands" },
    197: { name: "ADMIN - SETUP > Educator Notifications" },
    198: { name: "ADMIN - SETUP > Ramp Threshold Defaults" },
    199: { name: "ADMIN - SETUP > Hygienist Bracket System" },
    200: { name: "ADMIN - SETUP > Dr App Permission Matrix" },
    201: { name: "ADMIN - SETUP > Sage Accounts Description" },
    202: { name: "ADMIN - SETUP > Implant Cost" },
    203: { name: "ADMIN - SETUP > Provider Earnings Report" },
    204: { name: "ADMIN - SETUP > Financial Note Category" },
    205: { name: "ADMIN - USAGE" },
    206: { name: "MEMBERS - DASHBOARD" },
    207: { name: "MEMBERS - RTP1" },
    208: { name: "MEMBERS - Call Recordings" },
    209: { name: "MEMBERS - New Patient Origin" },
    210: { name: "MEMBERS - Contact Data Report" },
    211: { name: "MEMBERS - Quality Index Report" },
    212: { name: "MEMBERS - Priority Status Report" },
    213: { name: "MEMBERS - Lead Data Report" },
    214: { name: "MEMBERS - Members" },
    215: { name: "MEMBERS - Members Status Report" },
    216: { name: "MEMBERS - RTP 4" },
    217: { name: "MEMBERS - EVA" },
    218: { name: "MEMBERS - ADMIN" },
    219: { name: "MEMBERS - ADMIN" },
    220: { name: "MEMBERS - PP Patient Details" },
    221: { name: "MEMBERS - USAGE" },
    222: { name: "MEMBERS - DELETE APPOINTMENTS > By Group" },
    223: { name: "MEMBERS - DELETE APPOINTMENTS > Summery" },
    224: { name: "MEMBERS - DELETE APPOINTMENTS > Details" },
    225: { name: "ADMIN - SOFD > Logins" },
    226: { name: "APTOOD - API Configuration" },
    227: { name: "APTOOD - Patients" },
    228: { name: "APTOOD - Patients Logs" },
    229: { name: "ADMIN - SETUP > Ortho Provider Earnings Report" },
    230: { name: "Credentialing - Document Form" },
    231: { name: "UKG - Payrolls" },
    232 :{name :"SPOT - SUPPORT PATIENT OPPORTUNITY TOOL"}
}


